/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import type { CourseraPlusCtaPart } from 'bundles/coursera-plus-landing-page/__generated__/baseContentfulTypes';
import type { PickedLandingForTool } from 'bundles/coursera-plus-landing-page/contentful/fetchContentful';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import { tableStyles } from 'bundles/coursera-plus-landing-page/editorTool/PretranslatedListItem';

type Props = {
  page: PickedLandingForTool;
  translationKey?: string;
};

const contentfulEntryUrl = (entryId: string) => `https://app.contentful.com/spaces/wp1lcwdav1p1/entries/${entryId}`;

const CtaPartLinks = (props: Props) => {
  const parts = props.page.heroCtaPartsCollection?.items;
  if (!parts) {
    return null;
  }

  const partLink = (part: CourseraPlusCtaPart | null | undefined) => {
    if (!part) {
      return null;
    }
    if (part?.pretranslated !== props.translationKey) {
      return null;
    }
    const url = contentfulEntryUrl(part?.sys.id);
    return (
      <div>
        <a href={url} target="_blank" rel="noreferrer">
          {part.entryTitle}
        </a>
      </div>
    );
  };

  return <div>{parts.map(partLink)}</div>;
};

const LandingPageEntry = (props: Props) => {
  const { page } = props;
  const entryUrl = `https://app.contentful.com/spaces/wp1lcwdav1p1/entries/${page.sys.id}`;
  const pageUrl = `/courseraplus/special/${page.slug}`;

  return (
    <div css={tableStyles.separator}>
      <table>
        <tr>
          <td css={tableStyles.label}>Entry title:</td>
          <td>{page.title}</td>
        </tr>
        <tr>
          <td css={tableStyles.label}>Links:</td>
          <td>
            <a href={pageUrl} target="_blank" rel="noreferrer">
              landing / marketing page
            </a>
            <br />
            <a href={entryUrl} target="_blank" rel="noreferrer">
              page entry in Contentful
            </a>
          </td>
        </tr>
        <tr>
          <td css={tableStyles.label}>CTA parts</td>
          <td>
            <CtaPartLinks {...props} />
          </td>
        </tr>
      </table>
    </div>
  );
};

export default LandingPageEntry;
